<template>
  <v-row>
    <v-col cols="12">
      <v-card
        color="#EBF0FF"
        outlined
        class="rounded-lg"
        style="border-left: 8px solid #2661ff !important;"
      >
        <v-card-title
          class="subtitle-1 font-weight-medium"
          style="color: #2661FF;"
        >
          <v-icon color="#2661FF" class="px-4 mb-1">
            warning
          </v-icon>
          <span>{{ title }}</span>
        </v-card-title>
        <v-card-text>
          <v-row v-for="({ text, value }, index) in data.plan" :key="index">
            <v-col cols="12">
              <v-row>
                <v-col cols="6" class="d-flex justify-center align-center">
                  <span
                    class="body-1 text-center font-weight-light"
                    style="color: #2661FF; opacity: 80%;"
                  >
                    {{ text }}
                  </span>
                </v-col>
                <v-col cols="6" class="d-flex justify-center align-center">
                  <span class="body-1 text-center">
                    {{ value }}
                  </span>
                </v-col>
              </v-row>
            </v-col>
          </v-row>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-text>
          <v-icon color="#2661FF" class="px-4 mb-1">
            warning
          </v-icon>
          <span class="subtitle-1 font-weight-medium" style="color: #2661FF;">
            {{ subtitle }}
          </span>
          <v-card
            v-for="(service, index) in data.services"
            :key="index"
            class="rounded-lg my-2 py-2"
            style="color: #2661FF; opacity: 80%;"
            flat
          >
            <v-col cols="12">
              <v-row v-for="({ text, value }, index) in service" :key="index">
                <v-col cols="6" class="d-flex justify-center align-center">
                  <span
                    class="body-1 text-center font-weight-light"
                    style="color: #2661FF; opacity: 80%;"
                  >
                    {{ text }}
                  </span>
                </v-col>
                <v-col cols="6" class="d-flex justify-center align-center">
                  <span class="body-1 text-center">
                    {{ value }}
                  </span>
                </v-col>
              </v-row>
            </v-col>
          </v-card>
        </v-card-text>
      </v-card>
    </v-col>
  </v-row>
</template>

<script>
export default {
  name: 'OrganizationPlanSummary',
  props: {
    title: {
      type: String,
      required: true
    },
    subtitle: {
      type: String,
      required: true
    },
    data: {
      type: Object,
      required: true
    }
  },
  data() {
    return {}
  }
}
</script>

<style lang="scss" scoped></style>
